import { SearchOptions } from '@trustero/trustero-api-web/lib/search/search_pb'

export type SearchableData<T> = {
  id: string
  original: T
  searchableText: string
  contentIds?: string[]
}

export type SearchResults<T> = {
  data: T[]
  contentMatches: Set<string>
}

export type MetadataSearchResponse = {
  includedIds: string[]
  excludedIds: string[]
}

export type AdvancedSearchOptions = {
  exactMatch: string
  includeAny: string
  includeAll: string
  excludeAll: string
}

export enum SearchOperator {
  AND = 'AND',
  OR = 'OR',
}

export type SearchTermNode = {
  term?: string
  prefix?: string
  quoted?: boolean
  regex?: boolean
}

export type SearchBinaryNode = {
  left?: SearchASTNode
  operator?: SearchOperator
  right?: SearchASTNode
  parenthesized?: boolean
}

export type SearchASTNode = SearchTermNode | SearchBinaryNode

export type ContentSearchInput = {
  searchOptions: SearchOptions
  contentIds: string[]
  shouldFetch?: boolean
  trustPortalAccountId?: string
}
